module.exports = __webpack_public_path__ + "static/img/icon_util.4d130e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/icon_util.png
// module id = BLTL
// module chunks = 2